import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-stopping-you',
  	templateUrl: './toolcards-stopping-you.component.html',
  	styleUrls: ['./toolcards-stopping-you.component.scss']
})
export class ToolcardsStoppingYouComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
